<script setup lang="ts">
import type { SectionLocationInfoRecord } from '~/types/datocms'

const props = defineProps<{
  data: SectionLocationInfoRecord
  moduleIndex: number
}>()

const { level, isSemantic } = useSectionRules(props.moduleIndex, !!props.data.title)
</script>

<template>
  <section class="bg-cream pb-4 pt-8 text-black lg:py-12">
    <div class="container grid-default gap-y-0">
      <div class="col-span-full lg:col-span-3">
        <Heading
          v-if="data.title"
          :level="level"
          :is-semantic="isSemantic"
          :size="undefined"
          class="!text-lg uppercase text-yellow lg:!text-xl"
          >{{ data.title }}</Heading
        >
      </div>
      <div class="col-span-full flex flex-col gap-12 lg:col-span-9 lg:gap-20">
        <ul v-if="data.generalInfo" class="grid-default gap-y-6 uppercase lg:gap-y-8">
          <li
            v-if="data.generalInfo"
            class="col-span-full text-lg uppercase text-yellow lg:text-xl"
          >
            General info
          </li>
          <li
            v-for="(value, key) in data.generalInfo"
            :key="key"
            class="col-span-6 flex flex-col gap-1 lg:col-span-4 lg:gap-2"
          >
            <span class="text-lg lg:text-xl">
              {{ key }}
            </span>
            <span class="text-sm lg:text-base">
              {{ value }}
            </span>
          </li>
        </ul>
        <ul v-if="data.generalInfo" class="gap-y-6 uppercase lg:gap-y-8">
          <li v-if="data.holidays" class="mb-8 text-lg uppercase text-yellow lg:text-xl">
            Holidays
          </li>
          <li
            v-for="(value, key) in data.holidays"
            :key="key"
            class="grid-default mt-6 gap-y-0 lg:col-span-full lg:gap-2"
          >
            <span class="col-span-6 text-lg lg:col-span-4 lg:text-xl">
              {{ key }}
            </span>
            <div class="col-span-6 flex flex-col text-sm lg:col-span-8 lg:text-base">
              <span v-for="item in value.split(',')" :key="item">
                {{ item }}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
